import { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import EditNoteIcon from '@mui/icons-material/EditNote';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Box, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CollapsibleTable from '../../components/CollapsibleTable';
import ModalIncarcareSemnata from '../../components/ModalIncarcareSemnata';
import ModalModificari from '../../components/ModalModificari';
import { descarcaCerere, ultimaCerere } from '../../utils/descarcaCerere';
import MesajInchidere from '../../components/MesajInchidere';
import { usePlatforma } from '../../platforma';

function ToSign() {
    const SERVER = process.env.REACT_APP_SERVER;
    const [refresh, setRefresh] = useState(false);
    const [toSign, setToSign] = useState([]);
    const [uploadModal, setUploadModal] = useState(null);
    const [modificariModal, setModificariModal] = useState(null);
    const [prof, setProf] = useState();

    useEffect(() => {
        preluareProfesor();
        preluareStudenti();
    }, [refresh]);

    const preluareProfesor = async () => {
        const professorResponse = await fetch(`${SERVER}user`, {
            method: 'GET',
            headers: {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
        });
        const professorData = await professorResponse.json();
        setProf(professorData.instanta);
    }

    const preluareStudenti = async () => {
        const studResp = await fetch(`${SERVER}colaborari`, {
            method: 'GET',
            headers: {
                Authorization: localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
        });
        const studData = await studResp.json();
        const toSign = [];
        for (let student of studData.deSemnat) {
            const cerere = ultimaCerere(student);
            toSign.push({ ...student, cerere, titlu: cerere ? cerere.titlu : 'Nu are cerere.' });
        }
        setToSign(toSign);
    }

    const dupaActiune = () => {
        setUploadModal(null);
        setModificariModal(null);
        setRefresh(r => !r);
    };

    // dupa inchiderea platformei cererile pot fi doar descarcate
    const { inchisa } = usePlatforma();

    const renderButtons = (row) => (
        <>
            {!inchisa && <Button color="warning" startIcon={<EditNoteIcon />}
                onClick={e => {
                    e.preventDefault(); document.documentElement.scrollTop = 0; setModificariModal(row);
                }}>Solicită modificări</Button>}
            <Button startIcon={<DownloadIcon />} onClick={() => { descarcaCerere(row); }} > Descarcă </Button>
            {!inchisa && <Button startIcon={<UploadFileIcon />} onClick={() => {
                document.documentElement.scrollTop = 0; setUploadModal(row);
            }}>Încarcă cererea semnată</Button>}
        </>
    );

    return (
        <Box sx={{ margin: "100px 10px" }}>
          <MesajInchidere isProfessor />
          {prof && prof.grad_didactic ? (
           (prof.numar_studenti_maxim > 0 ?  <>
            {toSign.length ? <CollapsibleTable rows={toSign} renderButtons={renderButtons} columns={[
              { label: 'Nr.', id: 'nr' },
              { label: 'Email', id: 'email' },
              { label: 'An', id: 'an' },
              { label: 'Grupă', id: 'grupa' },
              { label: 'Titlu', id: 'titlu' },
              { label: '', id: 'buttons' }
          ]} /> : <Box sx={{ backgroundColor: "white", padding: "20px", margin: "100px 20px" }}>Nu aveți cereri de semnat.</Box>}
          {uploadModal && (
              <ModalIncarcareSemnata student={uploadModal} cerere={uploadModal.cerere} profesor={prof}
                  onInchide={() => setUploadModal(null)} onSucces={dupaActiune} />
          )}
          {modificariModal && (
              <ModalModificari student={modificariModal} cerere={modificariModal.cerere}
                  onInchide={() => setModificariModal(null)} onSucces={dupaActiune} />
          )}
          </> :  <Box sx={{ backgroundColor: "white", padding: "20px", margin: "20px" }}>
          Vă rugăm așteptați ca directorul de departament să vă seteze limita maximă admisă de studenți.</Box>)
          ) : <Box sx={{ backgroundColor: "white", padding: "20px", margin: "20px" }}>
                Completați datele personale în pagina de profil, din meniul lateral.</Box>}
        </Box>
    );
}

export default ToSign;
